<script setup>
import { ref } from "vue";
import { Dialog, DialogPanel } from "@headlessui/vue";
import { Bars3Icon, XMarkIcon } from "@heroicons/vue/24/outline";

const navigation = [
  { name: "Art", href: "/art" },
  { name: "Artist", href: "/artist" },
  { name: "Contact", href: "/contact" },
];

const mobileMenuOpen = ref(false);
</script>

<template>
  <header class="">
    <ContentWidthContainer>
      <nav class="flex items-center justify-between pt-6 pb-6 lg:pb-12" aria-label="Global">
        <NuxtLink href="/" class="flex items-center gap-6">
          <NuxtImg
            class="h-12 w-auto"
            src="/kate.png"
            height="48"
            width="48"
            format="webp"
            alt="A digital image created by and of the artist"
          />
          <div class="flex flex-col">
            <p class="text-xl md:text-2xl">Kate O. Nahodyl</p>
            <p class="font-serif text-base leading-tight md:text-lg">Artist</p>
          </div>
        </NuxtLink>
        <div class="flex md:hidden">
          <button
            type="button"
            class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            @click="mobileMenuOpen = true"
          >
            <span class="sr-only">Open main menu</span>
            <Bars3Icon class="h-6 w-6 fill-black" aria-hidden="true" />
          </button>
        </div>
        <div class="hidden md:flex md:gap-x-12">
          <NuxtLink v-for="item in navigation" :key="item.name" :href="item.href" class="text-xl leading-6 text-black">
            {{ item.name }}
          </NuxtLink>
        </div>
      </nav>
    </ContentWidthContainer>

    <Dialog as="div" class="lg:hidden" :open="mobileMenuOpen" @close="mobileMenuOpen = false">
      <div class="fixed inset-0 z-10" />

      <DialogPanel
        class="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
      >
        <div class="flex items-center justify-between">
          <NuxtLink href="/">
            <span class="sr-only">Kate O.Nahodyl, Artist</span>

            <div class="hover:bg-ice-100 flex items-center gap-6 rounded-md p-2.5">
              <NuxtImg
                class="h-12 w-auto"
                src="/kate.png"
                height="48"
                width="48"
                format="webp"
                alt="A digital image created by and of the artist"
              />

              <div class="flex flex-col">
                <h1 class="text-xl md:text-2xl">Kate O. Nahodyl</h1>

                <h2 class="font-serif text-lg">Artist</h2>
              </div>
            </div>
          </NuxtLink>

          <button type="button" class="-m-2.5 rounded-md p-2.5 text-black" @click="mobileMenuOpen = false">
            <span class="sr-only">Close menu</span>

            <XMarkIcon class="h-6 w-6" aria-hidden="true" />
          </button>
        </div>

        <div class="mt-6 flow-root">
          <div class="-my-6 divide-y divide-gray-500/10">
            <div class="space-y-2 py-6">
              <NuxtLink
                v-for="item in navigation"
                :key="item.name"
                :href="item.href"
                class="text-lge hover:bg-ice -mx-3 block rounded-lg px-3 py-2 leading-7 text-black"
                >{{ item.name }}
              </NuxtLink>
            </div>
          </div>
        </div>
      </DialogPanel>
    </Dialog>
  </header>
</template>
